<template>
    <div class="popwrap modulewrap">
        <component :is="pagepop" v-on="$listeners" :poptype="poptype" @update:poptype="updatepoptype"></component>
    </div>
</template>

<script>
    export default {
        name: 'pop',
        props: {
            popurl: {
                type: String,
                default: ''
            },
            poptype: {
                type: Number,
                default: 1
            }
        },
        computed: {
            pagepop: function () {
                return () => import('@/views/pop/' + this.popurl);
            }
        },
        methods: {
            updatepoptype: function (v) {
                this.$emit('update:poptype', v);
            }
        }
    };
</script>
